import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";

const AllOrders = () => {
  return <OrderTable status={0} isActive="ALL" />;
};

export default AllOrders;
